import React from 'react';
import { motion } from 'framer-motion';
import { Link as ScrollLink } from 'react-scroll';
import { MessageSquare, Layers } from 'lucide-react';
import Button from '../ui/Button';

const FinalCTA = () => {
  return (
    <section className="py-20 relative bg-white dark:bg-slate-950">
      <div className="container mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative max-w-5xl mx-auto rounded-3xl bg-gradient-to-br from-slate-900 to-slate-800 text-white p-10 md:p-16 shadow-2xl overflow-hidden"
        >
          {/* Subtle background tech accents */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-brand-500/10 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute bottom-0 left-0 w-80 h-80 bg-indigoBrand-500/10 rounded-full blur-3xl pointer-events-none" />

          <div className="relative z-10 max-w-2xl mx-auto text-center">
            <h2 className="text-3xl md:text-5xl font-display font-bold tracking-tight mb-4 text-white">
              Have an Idea Worth Building?
            </h2>

            <p className="text-slate-300 text-lg md:text-xl leading-relaxed mb-8 font-normal">
              Let's turn your idea into a practical technology solution.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <ScrollLink to="contact" smooth={true} duration={450} offset={-75}>
                <Button variant="primary" className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold shadow-md">
                  Start a Conversation
                  <MessageSquare size={17} />
                </Button>
              </ScrollLink>

              <ScrollLink to="products" smooth={true} duration={450} offset={-75}>
                <button className="w-full sm:w-auto px-8 py-3.5 rounded-xl border border-slate-700 bg-slate-800/80 hover:bg-slate-700/80 text-white text-base font-medium transition-all flex items-center justify-center gap-2">
                  Explore Our Products
                  <Layers size={17} />
                </button>
              </ScrollLink>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
